import React from "react";
import { css } from "@emotion/react";
import { CruiseCabinCard } from "../../../components/cruise/CruiseCabinCard";
import { CruiseCabinCardSkeleton } from "../../../components/cruise/CruiseCabinCardSkeleton";
import {
  isCabinRatesLoadingSelector,
  vesselCabinRatesSelector,
} from "../cruiseSlice";
import { useAppSelector } from "main/javascripts/store";
import { VesselCabinCategories } from "main/javascripts/constants/VesselCabinCategories";
import { space } from "main/javascripts/styles/base/spaceStyle";
import { cruiseShowParamSelector } from "../../../slices/paramSlice";

export const CruiseCabinList: React.FC = (): React.ReactElement => {
  const cabinRates = useAppSelector(vesselCabinRatesSelector);
  const isCabinRateLoading = useAppSelector(isCabinRatesLoadingSelector);
  const param = useAppSelector(cruiseShowParamSelector);

  const skeletonCount = 4;

  const cabinRatesData = Object.keys(VesselCabinCategories).map((key) => {
    const category = VesselCabinCategories[key];
    return cabinRates
      .filter((cabinRate) => cabinRate.cabinCategory === category)
      .sort((a, b) => a.priceCents - b.priceCents);
  });

  const saleCabinRatesData = Object.keys(VesselCabinCategories)
    .map((key) => {
      const category = VesselCabinCategories[key];
      const filteredRates = cabinRates
        .filter(
          (cabinRate) =>
            cabinRate.cabinCategory === category &&
            cabinRate.rate?.hasSalePrice === true
        )
        .sort((a, b) => {
          // 選択されたキャビンを最初に
          if (param.cabinCode) {
            if (a.cabinCode === param.cabinCode) return -1;
            if (b.cabinCode === param.cabinCode) return 1;
          }
          return a.priceCents - b.priceCents;
        });

      return filteredRates.length > 0 ? filteredRates : null;
    })
    // nullを除外
    .filter((rates): rates is NonNullable<typeof rates> => rates !== null)
    // 選択されたキャビンのカテゴリを最初に
    .sort((a, b) => {
      if (param.cabinCode) {
        const hasSelectedA = a.some(
          (rate) => rate.cabinCode === param.cabinCode
        );
        const hasSelectedB = b.some(
          (rate) => rate.cabinCode === param.cabinCode
        );
        if (hasSelectedA) return -1;
        if (hasSelectedB) return 1;
      }
      return 0;
    });

  return (
    <div css={cabinListStyle}>
      {saleCabinRatesData.length > 0 && (
        <div css={selectedCabinListStyle}>
          {saleCabinRatesData.map((cabinRates, index) => {
            return (
              <CruiseCabinCard
                key={index}
                cabinRates={cabinRates}
                param={param}
                isSale={true}
              />
            );
          })}
        </div>
      )}
      {isCabinRateLoading
        ? Array.from({ length: skeletonCount }).map((_, index) => (
            <CruiseCabinCardSkeleton key={index} />
          ))
        : cabinRatesData.map((cabinRates, index) => {
            if (!cabinRates || cabinRates.length === 0) {
              return null;
            }
            return (
              <CruiseCabinCard
                key={index}
                cabinRates={cabinRates}
                param={param}
              />
            );
          })}
    </div>
  );
};

const cabinListStyle = css`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr;
  gap: ${space.atom2x};
`;
const selectedCabinListStyle = css`
  padding-bottom: 2.5rem;
  display: grid;
  grid-template-columns: 1fr;
  gap: ${space.atom2x};
`;
